/**
 * vuex ui 상태
 * @name store/view
 * @type {State}
 * @property {String} locale locale
 * @property {Number} scrollTop scroll top 값
 * @property {Object} page 현재 메뉴 location 정보
 * @property {Object} header header
 * @property {number} header.height 높이
 * @property {number} header.open 열림 유무
 * @property {number} header.family 패밀리 영역 열림 유무
 * @property {Array} navMenu 햄거버 메뉴 열림 상태 값
 */

const state = () => ({
  locale   : null,
  scrollTop: 0,
  page     : [],
  header   : {
    height: 0,
    open  : false,
    family: false
  },
  navMenu: [false, false, false, false, false]
});

const getters = {};

const mutations = {
  /**
   * locale 정의
   * @param {*} state
   * @param {string} value
   */
  SET_LOCALE: (state, value) => {
    state.locale = value;
  },
  /**
   * scroll top 값 정의
   * @param {*} state
   * @param {number} value
   */
  SET_SCROLL_TOP: (state, value) => {
    state.scrollTop = value;
  },
  /**
   * 현재 메뉴 location 정보 정의
   * @param {*} state
   * @param {*} value
   */
  SET_PAGE: (state, value) => {
    state.page = value;
  },
  /**
   * header 높이 정의
   * @param {*} state
   * @param {number} value
   */
  SET_HEADER_HEIGHT: (state, value) => {
    state.header.height = value;
  },
  /**
   * header 열림 유무
   * @param {*} state
   * @param {boolean} value
   */
  SET_HEADER_OPEN: (state, value) => {
    state.header.open = value;
  },
  /**
   * header 패밀리 영역 열림 유무
   * @param {*} state
   * @param {boolean} value
   */
  SET_HEADER_FAMILY: (state, value) => {
    state.header.family = value;
  },
  /**
   * 햄거버 메뉴 열림 상태 정의
   * @param {*} state
   * @param {Array}} value
   */
  SET_MENU_REFRESH: (state, value) => {
    state.navMenu = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};
